import { JSX } from 'react'
import { TreeItem } from 'react-sortable-tree'
import { RemoveButton } from 'components/modelManager/atoms/buttons/Buttons'
import { RemoveAbleItemProps } from 'ts/interfaces'
import VisibilityButton from '../VisiblityButton'

interface NodeActionsProps {
    node: TreeItem
    presetId: number
    nodeActionButtonSx: any
    reRenderCallback: () => void
    setRemoveableItem: (item: RemoveAbleItemProps | null) => void
}

export const getNodeActions = ({
    node,
    presetId,
    nodeActionButtonSx,
    reRenderCallback,
    setRemoveableItem
}: NodeActionsProps): JSX.Element[] => {
    const { id, parent_id, presetNode } = node
    const buttons: JSX.Element[] = []

    // All visibility button
    if (node.children && node.children.length > 0) {
        buttons.push(
            <VisibilityButton
                key={`all-${id}`}
                node={node}
                presetId={presetId}
                sx={nodeActionButtonSx}
                reRenderCallback={reRenderCallback}
                includingChildNodes
            />
        )
    }

    // Visibility button
    buttons.push(
        <VisibilityButton
            key={`single-${id}`}
            presetId={presetId}
            node={node}
            sx={nodeActionButtonSx}
            reRenderCallback={reRenderCallback}
        />
    )

    // Remove button
    if (presetNode) {
        buttons.push(
            <RemoveButton
                key={id}
                sx={nodeActionButtonSx}
                onClick={() => {
                    setRemoveableItem({
                        id: +id,
                        parent_id: parent_id as any,
                        node: node as TreeItem
                    })
                }}
            />
        )
    }

    return buttons
}
